import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import StaticSearch from 'Components/StaticSearch/StaticSearch';
import { fetchLatestDeals } from 'Redux/ducks/algolia-calls';

const messages = defineMessages({
  title: {
    id: 'latestdeals.title',
    defaultMessage: 'Latest PC Game Deals',
  },
  fullTitle: {
    id: 'latestdeals.seotitle',
    defaultMessage: 'Latest PC and Steam Game Deals',
  },
  desc: {
    id: 'latestdeals.seodesc',
    defaultMessage: 'Top Sellers on great PC, Mac, and Linux games from over 750 top publishers. Whether you\'re looking for the latest, greatest games, or one of our exclusive bundles, we are Fanatical about always bringing you the best deals on the planet.',
  },
  seoBlurb: {
    id: 'latestdeals.seoBlurb',
    defaultMessage: 'If you’re looking for the latest and greatest deals right now, we\'re sure you’ll find a fantastic bargain on our site. Check out our latest PC game discounts here - we’ve got something for every budget.',
  },
  pcGameDeals: {
    id: 'latestdeals.pcgamedeals',
    defaultMessage: 'PC Game Deals',
  },
});


export default function LatestDeals() {
  const { formatMessage } = useIntl();

  const crumbs = [{
    label: formatMessage(messages.pcGameDeals),
    link: '/on-sale/',
  },
  {
    label: formatMessage(messages.title),
    link: '/latest-deals',
  },
  ];

  return (<StaticSearch
    updateHits={fetchLatestDeals}
    url="latest-deals"
    topBanner="latest_deals"
    crumbs={crumbs}
    {...messages}
  />);
}
